import { createContext } from "react";

export const AlertsContext = createContext({});
